import * as React from "react";
import { Text } from "@uikit";
import { CourseWeather, Daily } from "@kalabo/golfsavers-common";
import { kelvinToCelsius, mpsToKmh } from "@kalabo/golfsavers-common";
import { IoWaterSharp } from "@react-icons/all-files/io5/IoWaterSharp";
import { useBreakpoint } from "use-breakpoint";
import { BREAKPOINTS } from "@utilities/constants";

import { IoNavigate } from "@react-icons/all-files/io5/IoNavigate";
interface IProps {
  location: string;
  data: CourseWeather;
}

const CourseWeatherDisplay = ({ data, location }: IProps) => {
  const { breakpoint } = useBreakpoint(BREAKPOINTS, "mobile");
  // get next 5 days
  let weather = React.useMemo(() => {
    if (!data?.weather_data?.daily) return [];

    let weather = data?.weather_data?.daily?.filter((day: Daily) => {
      // only return days that are in the future
      return day.dt * 1000 > Date.now();
    });

    switch (breakpoint) {
      case "mobile":
        return weather?.slice(0, 3);
      case "tablet":
        return weather?.slice(0, 4);
      default:
        return weather?.slice(0, 5);
    }
  }, [data, breakpoint]);

  if (!weather) return null;
  if (weather.length === 0) return null;

  return (
    <div className="mb-10 flex-col flex flex-1 overflow-hidden">
      <Text
        size={17}
        element="h3"
        weight="semibold"
        color="black90"
        leading={1.3}
        className="mb-4"
      >
        Weather Forecast for {location}
      </Text>
      <div className="flex flex-wrap gap-2">
        {weather.map((day: Daily, index) => {
          let dayOfWeek = new Date(day.dt * 1000).toLocaleDateString("en-US", {
            weekday: "long",
          });
          // if dayOfWeek is today, display "Today"
          if (index === 0) {
            dayOfWeek = "Tomorrow";
          }
          return (
            <div
              key={index}
              className="bg-grey py-5 text-center flex items-center justify-center flex-1 flex-col gap-[8px]"
            >
              <Text size={15} weight="semibold" color={"black90"} leading={1.3}>
                {dayOfWeek}
              </Text>

              <img
                src={`${process.env.GATSBY_IMAGE_PREFIX}website/icons/weather/weather-icon-${day.weather[0].icon}.svg`}
                alt=""
              />

              <Text size={13} color={"black90"} leading={1.5}>
                {day.weather[0].main}
              </Text>

              <Text size={19} weight="semibold" color={"red"} leading={1.3}>
                {kelvinToCelsius(day.temp.max)}
              </Text>
              <Text size={17} weight="semibold" color={"blue"} leading={1.3}>
                {kelvinToCelsius(day.temp.min)}
              </Text>

              <Text
                size={13}
                color={"black90"}
                leading={1.5}
                className="inline-flex items-center justify-center"
              >
                <IoWaterSharp className="inline text-blue h-5 w-5" />{" "}
                {day.humidity}%
              </Text>

              <Text size={13} color={"black90"} leading={1.5}>
                <span>
                  <IoNavigate
                    style={{
                      transform: `rotate(${day.wind_deg - 45}deg)`,
                    }}
                    className="inline text-black  h-5 w-5"
                  />
                </span>{" "}
                {mpsToKmh(day.wind_speed)}
              </Text>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CourseWeatherDisplay;
